<template>
  <div class="user-notifications-empty-state">
    <svg-loader class="user-notifications-empty-state-icon" src="/assets/images/icon-notification.svg" />
    <strong>{{ $t('commonText.noNewNotification') }}</strong>
    <p>{{ $t('commonText.noNewNotificationDesc') }}</p>
  </div>
</template>

<script>
  export default {
    name: 'UserNotificationsEmptyState'
  }
</script>

<style lang="scss" scoped>
  @import '~stylesheets/meta';

  .user-notifications-empty-state {
    padding: 36px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    line-height: 1.5em;
    text-align: center;
  }

  .user-notifications-empty-state-icon {
    width: 36px;
    margin-bottom: 24px;
    fill: $color-red-orange;
  }

  strong {
    color: $color-red-orange;
  }
</style>
